import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00dae3",
      dark: "#00b8bf",
      light: "#5eeef5",
      contrastText: "#000",
    },
    secondary: {
      main: "#e3ff3f",
      dark: "#c8e636",
      light: "#eaff6b",
      contrastText: "#000",
    },
    background: {
      default: "#f0fffe",
      paper: "rgba(255, 255, 255, 0.88)",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.88)",
      secondary: "rgba(0, 0, 0, 0.65)",
    },
    error: {
      main: "#d32f2f",
    },
    info: {
      main: "#00dae3",
    },
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h1: { fontFamily: "pawwash, system-ui, sans-serif" },
    h2: { fontFamily: "pawwash, system-ui, sans-serif" },
    h3: { fontFamily: "pawwash, system-ui, sans-serif" },
    h4: { fontFamily: "pawwash, system-ui, sans-serif" },
    h5: { fontFamily: "pawwash, system-ui, sans-serif" },
    h6: { fontFamily: "pawwash, system-ui, sans-serif" },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: "8px 24px",
          transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 4px 24px rgba(227, 255, 63, 0.4)",
          },
        },
        contained: {
          backgroundColor: "rgba(226, 255, 63, 0.75)",
          color: "#000",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
          "&:hover": {
            backgroundColor: "rgba(226, 255, 63, 0.9)",
          },
        },
        outlined: {
          borderColor: "rgba(0, 0, 0, 0.4)",
          color: "#000",
          "&:hover": {
            borderColor: "#00dae3",
            backgroundColor: "rgba(0, 218, 227, 0.08)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            "&.Mui-focused fieldset": {
              borderColor: "#00dae3",
            },
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(14, 209, 235, 0.55)",
          backdropFilter: "blur(12px)",
          border: "2px solid rgba(227, 255, 63, 0.45)",
          borderRadius: "16px !important",
          marginBottom: "0.75rem",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12)",
          transition: "box-shadow 0.3s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.3s",
          "&::before": { display: "none" },
          "&.Mui-expanded": {
            borderColor: "rgba(0, 218, 227, 0.6)",
            boxShadow: "0 4px 24px rgba(0, 218, 227, 0.35)",
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          color: "#fff",
          minHeight: 56,
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.85)",
          lineHeight: 1.6,
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: "#000",
          borderColor: "rgba(0, 0, 0, 0.25)",
          textTransform: "none",
          "&.Mui-selected": {
            backgroundColor: "rgba(226, 255, 63, 0.65)",
            color: "#000",
            "&:hover": {
              backgroundColor: "rgba(226, 255, 63, 0.85)",
            },
          },
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: "rgba(255, 255, 255, 0.4)",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
